import { FormikErrors, FormikValues } from 'formik';
import { validateContractBaseInfo, ContractFormFields } from '../validations/contract.validations';

export const validate = (values: FormikValues): FormikErrors<ContractFormFields> => validateContractBaseInfo(values);
